import React, { PropsWithChildren } from "react";
//#region types
import { EntityViewLayoutProps } from "models/propTypes/pageLayoutPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import GridR from "../grid/responsiveGrid";
//#endregion
import { CSSHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const EntityViewLayout: React.FC<PropsWithChildren<EntityViewLayoutProps>> = (props) => {
  const { displayType, leftColumnSize } = props;

  const leftColumnSizeLg = leftColumnSize === "sm" ? 3 : 4.8;
  const rightColumnSizeLg = leftColumnSize === "sm" ? 9 : 7.2;
  return (
    <Grid
      container
      className={clsx(cssExports.entityViewContainer, CSSHelper.getClassByDisplayType(displayType))}
      direction="column"
    >
      <Grid item container spacing={3} className={cssExports.upperContainer}>
        <Grid item container md={3} lg={leftColumnSizeLg}>
          {props.upperLeftComponent}
        </Grid>
        <Grid item container md={9} lg={rightColumnSizeLg} direction="column" justifyContent="flex-end">
          {props.upperRightComponent}
        </Grid>
      </Grid>
      <GridR item container spacing={4}>
        <Grid item container md={3} lg={leftColumnSizeLg} className={cssExports.lowerLeftContainer}>
          {props.lowerLeftComponent}
        </Grid>
        <Grid
          item
          container
          md={9}
          lg={rightColumnSizeLg}
          direction="column"
          className={cssExports.viewPanelItemContainer}
        >
          {props.children}
          {props.footer && <props.footer.type key={props.footer.key} {...props.footer.props} showNavigateBack={true} />}
        </Grid>
      </GridR>
    </Grid>
  );
};

export default EntityViewLayout;
